const backend = {
  en: {
    api001: "Password must contain at least 8 characters.",
    api002: "The password must contain at least one number.",
    api003: "The password should contain at least one uppercase character.",
    api004: "The password must contain at least one lowercase letter.",
    api005: "The password must contain at least one special character.",
    api006: "Incorrect username and/or password.",
    api007: "Unauthorized.",
    api008: "Your login has been blocked, please wait 30 minutes to try again.",
    api009: "Passwords do not match.",
    api010: "The user has already logged in for the first time.",
    api011: "User is already registered in the system.",
    api012: "User does not exist in the system.",
    api013: "Code does not match.",
    api014: "Code expired",
    api015: "Invalid fields.",
    api016: "Profile not found.",
    api017: "Authorized.",
    api018: "Invalid data! Please review submitted data form.",
    api019: "Invalid e-mail.",
    api020: "Token subscription has expired.",
    api021: "Resend the code successfully.",
    api022: "Permission not found.",
    api023: "Unavailable service.",
    api024: "User created successfully.",
    api025: "Password changed successfully",
    api026: "The amount of permissions sent is incorrect.",
    api027: "The system does not have registered permissions, contact support.",
    api028:
      "The informed permission does not exist in the registration, please contact support.",
    api029: "There are two or more duplicate permissions.",
    api030: "Profile created successfully and awaiting administrator approval.",
    api031: "Profile must be active to cancel the creation request.",
    api032: "Profile must be awaiting approval in order to be cancelled.",
    api033: "Profile canceled successfully.",
    api034: "Profile already registered in the system.",
    api035: "Permission created successfully.",
    api036: "User successfully updated.",
    api037: "User successfully deleted.",
    api038: "Only administrators or superusers can perform this action.",
    api039: "Ability not found",
    api040: "Ability not registered in the system",
    api041: "Ability duplicate",
    api042: "Ability registered successfully",
    api043: "Objective not found",
    api044: "Objective successfully deleted",
    api045: "Target not found",
    api046: "Objective updated successfully",
    api047: "Target successfully deleted",
    api048: "Target updated successfully",
    api049: "Fact not found. ",
    api050: "Invalid Origin Type. ",
    api051: "Fact registered successfully.",
    api052: "Success.",
    api053: "Fact updated successfully.",
    api054: "Fact deleted successfully.",
    api055: "Access token has been revoke",
    api056: "Email successfully sent",
    api057: "Favorite not found",
    api058: "You are not allowed to perform this action.",
    api059: "The image dimensions cannot be larger than 512px.",
    api060: "Favorites created successfully.",
    api061: "Favorites not found.",
    api062: "Agent configuration not found.",
    api063: "Agent configuration registered successfully.",
    api064: "Agent configuration updated successfully.",
    api065: "Schedule created successfully.",
    api066: "Schedule not found.",
    api067: "Incorrect image format, send image in png, jpeg and jpg format.",
    api068: "Incorrect double-factor verification type.",
    api069: "Unmarked favorite",
    api070: "Abilities not found.",
    api071: "",
    api072: "Profile successfully updated.",
    api073: "This profile has been approved and is available for use.",
    api074: "This profile was canceled and is no longer available for use.",
    api075:
      "his profile does not match Raidstorm's needs. We suggest using one of the existing profiles.",
    api076: "Manual capture or update successfully performed.",
    api077: "Connection not found.",
    api078: "Version not found.",
    api079: "Image dimensions cannot be larger than 1024px.",
    api080: "Version created successfully.",
    api081: "Adversary not found",
    api082: "Successfully registered adversary",
    api083: "Adversary successfully changed",
    api084: "Adversary without registered skills",
    api085: "Adversary already registered previously, review the data",
    api086: "Abilities successfully validated for this adversary",
    api087: "The following abilities have prerequisites to perform correctly:",
    api088: "Adversary successfully deleted",
    api089: "Operation not found",
    api090: "Operation successfully changed",
    api091: "Operation successfully registred",
    api092: "Maximum jitter cannot be less than or equal to minimum",
    api093: "Invalid color",
    api094: "Failed to compile Agent in Go.",
    api095: "No agents available for execution of operation",
    api096: "Active",
    api097: "Inactive",
    api098: "Waiting Deactivaion",
    api099: "Trusted",
    api100: "Untrusted",
    api101: "Operation is finished",
    api102: "Successfully registered agent",
    api103: "Agent changed successfully",
    api104: "Invalid file format, send in png, jpeg, jpg or pdf format",
    api105: "Company already registered",
    api106: "Failed to send the code",
    api107: "Your login has been blocked, wait 24 hours to try again.",
    api108:
      "The following abilities may be out of order for the correct execution of this opponent:",
    api109: "Abilities in technical analysis",
    api110: "Content created successfully",
    api111: "Content updated successfully",
    api112: "Double factor reporting does not exist.",
    api113: "Filter sent incorrectly. Sending example: filter_column:value.",
    api114: "Adversario incompatible con la plataforma del agente",
    api115:
      "An error occurred when trying to execute a query to return the operation.",
    api116: "Failed to generate report, please try again.",
    api117: "Please wait, report processing.",
    api118: "Awaiting Activation",
    api119: "Notification successfully created.",
    api120: "Fact already created with these values.",
    api121: "Too Many Requests",
    api122: "Company informed for skills registration not located.",
    api123:
      "The number of imported files does not match the number entered in the yaml file.",
    api124: "The imported file does not have the .yaml extension.",
    api125: "Fact to be excluded wasn't found",
    api126:
      "Number of files sent does not correspond to the required number of Payloads.",
    api127: "There is already a Ability with that name registered",
    api128: "Ability successfully created.",
    api129: "There was an error creating the company, please contact support.",
    api130: "The selected Agent is already being used in another operation.",
    api131: "Select an active Agent.",
    api132: "No obfuscators found",
    api133: "The default Adversary cannot be removed.",
    api134: "Adversary cannot be removed as it is being used in attack.",
    api135: "Generating a report, it will be available within a few moments.",
    api136: "An error occurred while generating report.",
    api137: "Platform for generating command file is incorrect.",
    api138: "An error occurred while generating the filename or command.",
    api139: "TLS was not informed.",
    api140: "Rule to be deleted was not found.",
    api141: "Rule deleted successfully.",
    api142: "Rule not found.",
    api143: "Rule already created with these values.",
    api144: "Rule registered successfully.",
    api145: "Rule updated successfully.",
    api146: "An error occurred when trying to download the pdf or preview.",
    api147: "Sending a scraping message to the queue successfully completed.",
    api148: "Assessment not found",
    api149: "Assessment without registered responses",
    api150: "The following answers have techniques to process correctly.",
    api151: "Successfully registered Assessment",
    api152: "Successfully updated Assessment",
    api153: "Successfully deleted Assessment(s)",
    api154: "Response not found",
    api155: "File different from the one in the base",
    api156:
      "To accept the Assessment, it is necessary to download the list of questions.",
    api157:
      "To accept the Assessment, it is necessary to send an evidence file.",
    api158:
      "Downloading the list of questions can only be completed if the Assessment has been completely completed.",
    api159: "Customer acceptance has already been made.",
    api160: "Fail on assessment data registration/update",
    api161: "Assessment don't can be removed",
    api162: "Write file error ",
    api163: "Invalid file extension",
    api164: "Assessment to be deleted was not found",
    api165: "Mandatory Mitigation Type is necessary",
    api166: "Fail on exclude report(s)",
    api167: "Report(s) excluded sussessful",
    api168: "Report not found",
    api169: "Parser result registration completed successfully.",
    api170: "Update of parser result done successfully.",
    api171: "Ability cannot be edited",
    api172: "Successful edited ability",
    api173: "Failed to remove payload"
  },
  pt: {
    api001: "A senha deve conter pelo menos 8 caracteres.",
    api002: "A senha deve conter pelo menos um número.",
    api003: "A senha deve conter pelo menos uma letra maiúscula.",
    api004: "A senha deve conter pelo menos uma letra minúscula.",
    api005: "A senha deve conter pelo menos um caractere especial.",
    api006: "Usuário e/ou senha incorretos.",
    api007: "Não autorizado.",
    api008:
      "Seu login foi bloqueado, aguarde 30 minutos para tentar novamente.",
    api009: "As senhas não conferem.",
    api010: "O usuário já fez o primeiro acesso.",
    api011: "Usuário já possui cadastro no sistema.",
    api012: "Usuário não existe no sistema.",
    api013: "Código não confere.",
    api014: "Código expirou.",
    api015: "Campos inválidos.",
    api016: "Perfil não encontrado.",
    api017: "Autorizado.",
    api018: "Dados inválidos! Favor revisar formulário de dados enviado.",
    api019: "E-mail inválido.",
    api020: "A assinatura do token expirou.",
    api021: "Reenvio do código feito com sucesso.",
    api022: "Permissão não encontrada.",
    api023: "Serviço indisponivel.",
    api024: "Usuário criado com sucesso.",
    api025: "Senha alterada com sucesso",
    api026: "A quantidade de permissões enviadas estão incorreto.",
    api027:
      "O sistema não possui permissões cadastrada, entre em contato com o suporte.",
    api028:
      "A permissão informada não existe no cadastro, favor entrar em contato com o suporte.",
    api029: "Existe duas ou mais permissões duplicadas.",
    api030:
      "Perfil criado com sucesso e no aguardo de aprovação do administrador.",
    api031:
      "Perfil deve estar ativo para cancelamento da requisição de criação.",
    api032: "Perfil deve estar aguardando aprovação para poder ser cancelado.",
    api033: "Perfil cancelado com sucesso.",
    api034: "Perfil já cadastrado no sistema.",
    api035: "    Permissão criado com sucesso.",
    api036: "Usuário atualizado com sucesso.",
    api037: "Usuário apagado com sucesso.",
    api038: "Apenas administradores ou superusuários podem executar essa ação.",
    api039: "Habilidade não encontrada",
    api040: "Habilidade não cadastrada no sistema",
    api041: "Habilidade duplicada",
    api042: "Habilidade cadastrada com sucesso",
    api043: "Objetivo não encontrado",
    api044: "Objetivo excluído com sucesso",
    api045: "Meta não encontrada",
    api046: "Objetivo atualizado com sucesso",
    api047: "Meta excluída com sucesso",
    api048: "Meta atualizada com sucesso",
    api049: "Fact não encontrado.",
    api050: "Origin Type inválida.",
    api051: "Fact cadastrado com sucesso.",
    api052: "Sucesso.",
    api053: "Fact atualizado com sucesso.",
    api054: "Fact excluído com sucesso.",
    api055: "O token de acesso foi revogado",
    api056: "E-mail enviado com sucesso",
    api057: "Favorito não encontrado",
    api058: "Você não tem permissão para realizar essa ação.",
    api059: "As dimensões da imagem não podem ser maiores que 512px.",
    api060: "Favoritos criado com sucesso.",
    api061: "Favoritos não encontrado.",
    api062: "Configuração de agente não encontrado.",
    api063: "Configuração de agente cadastrado com sucesso.",
    api064: "Configuração de agente atualizado com sucesso.",
    api065: "Cronograma criado com sucesso.",
    api066: "Cronograma não encontrado.",
    api067:
      "Formato da imagem incorreto, enviar imagem no formato png, jpeg e jpg.",
    api068: "Tipo de verificação duplo-fator incorreto.",
    api069: "Favorito desmarcado",
    api070: "Habilidade não encontrada.",
    api071: "Habilidade alterada com sucesso.",
    api072: "Perfil atualizado com sucesso.",
    api073: "Este perfil já foi aprovado e está disponível para ser utilizado.",
    api074:
      "Este perfil foi cancelado e não se encontra mais disponível para uso.",
    api075:
      "Este perfil não corresponde às necessidades do Raidstorm. Sugerimos utilizar um dos perfis já existentes.",
    api076: "Captura ou atualização manual realizada com sucesso.",
    api077: "Conexão não encontrada.",
    api078: "Versão não encontrada.",
    api079: "As dimensões da imagem não podem ser maiores que 1024px.",
    api080: "Versão criada com sucesso.",
    api081: "Adversário não encontrado",
    api082: "Adversário cadastrado com sucesso",
    api083: "Adversário alterado com sucesso",
    api084: "Adversário sem habilidades cadastradas",
    api085: "Adversário já cadastrado anteriormente, reveja os dados",
    api086: "Habilidades validados com sucesso para este adversário",
    api087:
      "As seguintes habilidades possuem pré-requisitos para executar corretamente:",
    api088: "Adversário excluído com sucesso",
    api089: "Operação não encontrada",
    api090: "Operação alterada com sucesso",
    api091: "Operação cadastrada com sucesso",
    api092: "Jitter máximo não pode ser menor ou igual ao minimo",
    api093: "Cor inválida",
    api094: "Falha ao compilar Agente em Go.",
    api095: "Nenhum agente disponível para execução da operação",
    api096: "Ativo",
    api097: "Inativo",
    api098: "Aguardando Desativação",
    api099: "Confiável",
    api100: "Não Confiável",
    api101: "Operação esta finalizada",
    api102: "Agente cadastrado com sucesso",
    api103: "Agente alterado com sucesso",
    api104:
      "Formato dos arquivos inválido, enviar no formato png, jpeg, jpg ou pdf",
    api105: "Empresa já cadastrada",
    api106: "Falha no envio do código",
    api107: "Seu login foi bloqueado, aguarde 24 horas para tentar novamente.",
    api108:
      "As seguintes habilidades podem estar fora de ordem para a execução correta deste adversário:",
    api109: "Habilidades em análise técnica.",
    api110: "Conteúdo criado com sucesso",
    api111: "Conteúdo atualizado com sucesso",
    api112: "Duplo fator informado não existe.",
    api113:
      "Filtro enviado de forma incorreta. Exemplo de envio: filter_column:valor.",
    api114: "Adversário incompativel com a plataforma do agent",
    api115:
      "Ocorreu um erro ao tentar executar uma query para retorno da operação.",
    api116: "Falha ao gerar relatório, tente novamente.",
    api117: "Aguarde, relatório em processamento.",
    api118: "Aguardando Ativação",
    api119: "Notificação criado com sucesso.",
    api120: "Fact já criado com esses valores.",
    api121: "Muitas solicitações",
    api122: "Empresa informada para cadastro de habilidades não localizada.",
    api123:
      "Quantidade de  arquivos importados não corresponde a informada no arquivo yaml.",
    api124: "O arquivo importado não é da extensão .yaml.",
    api125: "Fact a ser excluído não foi encontrado",
    api126:
      "Quantidade de arquivos enviados não corresponde com a quantidade necessária de Payloads.",
    api127: "Já existe uma Habilidade com esse nome cadastrada",
    api128: "Habilidade criada com sucesso.",
    api129:
      "Ocorreu um erro na criação da empresa, entrar em contato com suporte.",
    api130: "O Agente selecionado já está sendo usado em outra operação.",
    api131: "Selecione um Agente ativo.",
    api132: "Nenhum obfuscator encontrado",
    api133: "Adversário padrão não pode ser removido.",
    api134: "Adversário não pode ser removido pois está sendo usado em ataque.",
    api135:
      "Gerando relatório, dentro de alguns instantes ele estará disponível.",
    api136: "Ocorreu um erro ao gerar relatório.",
    api137: "Plataforma para gerar arquivo do comando está incorreta.",
    api138: "Ocorreu um erro ao gerar o filename ou comando.",
    api139: "O TLS não foi informado.",
    api140: "Regra a ser excluída não foi encontrada.",
    api141: "Regra excluída com sucesso.",
    api142: "Regra não encontrada.",
    api143: "Regra já criada com esses valores.",
    api144: "Regra cadastrada com sucesso.",
    api145: "Regra atualizada com sucesso.",
    api146: "Ocorreu um erro ao tentar fazer download do pdf ou preview.",
    api147: "Envio de mensagem do scraping para fila feita com sucesso.",
    api148: "Avaliação não encontrada",
    api149: "Avaliação sem respostas cadastradas",
    api150:
      "Às seguintes respostas possuem técnicas para processar corretamente.",
    api151: "Avaliação cadastrada com sucesso",
    api152: "Avaliação alterada com sucesso",
    api153: "Avaliação(ões) excluida(s) com sucesso",
    api154: "Resposta não encontrada",
    api155: "Arquivo diferente do existente na base",
    api156:
      "Para realizar o aceite do Assessment, é necessário baixar da lista de questões.",
    api157:
      "Para realizar o aceite do Assessment, é necessário enviar um arquivo de evidência.",
    api158:
      "Download da lista de questões só pode ser concluído se Assessment estiver sido totalmente preenchido.",
    api159: "Aceite do cliente já foi realizado.",
    api160: "Falha no registro/atualização dos dados de avaliação",
    api161: "Avaliação não pode ser removida",
    api162: "Falha na gravação do arquivo",
    api163: "Extensão de arquivo invalida",
    api164: "Assessment a ser excluído não foi encontrado",
    api165: "Tipo de mitigação obrigatória",
    api166: "Falha ao excluir relatório(s)",
    api167: "Relatório(s) excluído(s) com sucesso",
    api168: "Relatório não encontrado",
    api169: "Cadastro parser result feito com sucesso.",
    api170: "Update do parser result feito com sucesso.",
    api171: "Habilidade não pode ser editada",
    api172: "Habilidade editada com sucesso",
    api173: "Falha ao remover payload"
  },
  es: {
    api001: "La contraseña debe contener al menos 8 caracteres.",
    api002: "La contraseña debe contener al menos un número.",
    api003: "La contraseña deberá contener al menos una letra mayúscula.",
    api004: "La contraseña debe contener al menos una letra minúscula.",
    api005: "La contraseña debe contener al menos un carácter especial.",
    api006: "Nombre de usuario y / o contraseña incorrectos.",
    api007: "No autorizado.",
    api008:
      "Su inicio de sesión ha sido bloqueado, espere 30 minutos para volver a intentarlo.",
    api009: "Las contraseñas no coinciden.",
    api010: "El usuario ya ha iniciado sesión por primera vez.",
    api011: "El usuario ya está registrado en el sistema.",
    api012: "El usuario no existe en el sistema.",
    api013: "El código no coincide.",
    api014: "Código caducado",
    api015: "Campos inválidos.",
    api016: "Perfil no encontrado.",
    api017: "Autorizado.",
    api018: "Datos inválidos! Revise el formulario de datos enviado.",
    api019: "Email inválido.",
    api020: "La suscripción del token ha caducado.",
    api021: "Reenviar el código con éxito.",
    api022: "Permiso no encontrado.",
    api023: "Servicio no disponible.",
    api024: "Usuario creado con éxito.",
    api025: "Contraseña alterada con éxito",
    api026: "La cantidad de permisos enviados es incorrecta.",
    api027: "El sistema no tiene permisos registrados, contacte a soporte.",
    api028:
      "El permiso informado no existe en el registro, por favor contacte a soporte.",
    api029: "Hay dos o más permisos duplicados.",
    api030:
      "Perfil creado con éxito y pendiente de aprobación del administrador.",
    api031:
      "El perfil debe estar activo para cancelar la solicitud de creación.",
    api032: "El perfil debe estar esperando aprobación para ser cancelado.",
    api033: "Perfil cancelado con éxito.",
    api034: "Perfil ya registrado en el sistema.",
    api035: "Permiso creado con éxito.",
    api036: "Usuario actualizado correctamente.",
    api037: "Usuario eliminado con éxito.",
    api038:
      "Solo los administradores o superusuarios pueden realizar esta acción.",
    api039: "Habilidad no encontrada",
    api040: "Habilidad no registrada en el sistema",
    api041: "Habilidad duplicada",
    api042: "Habilidad registrada con éxito",
    api043: "Objetivo no encontrado",
    api044: "Objetivo eliminado con éxito",
    api045: "Meta no encontrada",
    api046: "Objetivo actualizado con éxito",
    api047: "Meta eliminada con éxito",
    api048: "Meta actualizada con éxito",
    api049: "Fact no encontrado.",
    api050: "Origin Type no válido",
    api051: "Fact registrado con éxito.",
    api052: "Éxito.",
    api053: "Fact actualizado con éxito.",
    api054: "Fact eliminado con éxito.",
    api055: "El token de acceso ha sido revocado",
    api056: "Email enviado con éxito",
    api057: "Favorito no encontrada",
    api058: "No tiene permiso para realizar esta acción.",
    api059: "Las dimensiones de la imagen no deben ser superiores a 512px.",
    api060: "Favoritos creados con éxito.",
    api061: "Favoritos no encontrados.",
    api062: "Configuración del agente no encontrado.",
    api063: "Configuración del agente registrado con éxito.",
    api064: "Configuración del agente actualizado con éxito.",
    api065: "La lista creada con éxito.",
    api066: "La lista no encontrada.",
    api067:
      "Formato de imagen incorrecto, enviar imagen en formato png, jpeg y jpg.",
    api068: "Tipo de verificación de doble-factor incorrecto.",
    api069: "Favorito sin marcar",
    api070: "habilidad no encontrada.",
    api071: "",
    api072: "Perfil actualizado con éxito.",
    api073:
      "Este perfil ya está aprobado y está disponible para ser utilizado.",
    api074:
      "Este perfil se canceló y no se encuentra más disponible para su uso.",
    api075:
      "Este perfil no coincide con las necesidades de Raidstorm. Sugerimos utilizar uno de los perfiles existentes.",
    api076: "Captura manual o actualización realizada con éxito.",
    api077: "Conexión no encontrada.",
    api078: "Versión no encontrada.",
    api079: "Las dimensiones de la imagen no pueden ser mayores a 1024px.",
    api080: "Versión creada con éxito.",
    api081: "Adversario no encontrado",
    api082: "Adversario registrado con éxito",
    api083: "Adversario cambiado con éxito",
    api084: "Adversario sin habilidades registradas",
    api085: "Adversario ya registrado anteriormente, revisa los datos",
    api086: "Habilidades validadas con éxito para este adversario",
    api087:
      "Las siguientes habilidades tienen requisitos previos para funcionar correctamente:",
    api088: "Adversario eliminado con éxito",
    api089: "Operação não encontrada",
    api090: "Operação combiado con éxito",
    api091: "Operação registrada con éxito",
    api092: "La fluctuación máxima no puede ser menor o igual que la mínima",
    api093: "Color no válido",
    api094: "No se pudo compilar el agente en Go.",
    api095: "No hay agentes disponibles para la ejecución de la operación",
    api096: "Activo",
    api097: "Inactivo",
    api098: "Esperando Desactivación",
    api099: "De Confianza",
    api100: "No es Confiable",
    api101: "La operación ha terminado",
    api102: "Agente registrado con éxito",
    api103: "Agente cambiado con éxito",
    api104:
      "Formato de archivo no válido, enviar en formato png, jpeg, jpg o pdf",
    api105: "Empresa ya registrada",
    api106: "Error al enviar el código",
    api107:
      "Su inicio de sesión ha sido bloqueado, espere 24 horas para volver a intentarlo.",
    api108:
      "Las siguientes habilidades pueden estar fuera de orden para la correcta ejecución de este adversario:",
    api109: "Habilidad de análisis técnica.",
    api110: "Contenido creado con éxito",
    api111: "Contenido actualizado con éxito",
    api112: "El doble factor de notificación no existe.",
    api113:
      "Filtro enviado incorrectamente. Ejemplo de envío: filter_column:value.",
    api114: "Incompatible adversary with agent platform",
    api115:
      "Se ha producido un error al intentar ejecutar una consulta para devolver la operación.",
    api116: "No se pudo generar el informe, inténtalo de nuevo.",
    api117: "Por favor espere, reporte en proceso.",
    api118: "Esperando Activación",
    api119: "Notificación creada correctamente.",
    api120: "Fact ya creado con estos valores.",
    api121: "Muchas peticiones",
    api122: "Empresa informada para registro de competencias no localizada.",
    api123:
      "El número de archivos importados no coincide con el número introducido en el archivo yaml.",
    api124: "El archivo importado no tiene la extensión .yaml",
    api125: "Fact a eliminar no encontrado",
    api126:
      "La cantidad de archivos enviados no corresponde a la cantidad requerida de cargas útiles.",
    api127: "Ya existe una Ability con ese nombre registrada",
    api128: "Habilidad creada con éxito.",
    api129:
      "Se ha producido un error al crear la empresa, póngase en contacto con el servicio de asistencia.",
    api130:
      "El Agente seleccionado ya está siendo utilizado en otra operación.",
    api131: "Seleccione un Agente activo.",
    api132: "No se encontraron obfuscators",
    api133: "El Adversario predeterminado no se puede eliminar.",
    api134:
      "El Adversario no puede ser eliminado ya que está siendo utilizado en un ataque.",
    api135: "Generando un informe, estará disponible en unos momentos.",
    api136: "Se produjo un error al generar el informe.",
    api137: "La plataforma para generar el archivo de comando es incorrecta.",
    api138: "Se produjo un error al generar el nombre de archivo o el comando.",
    api139: "TLS no fue informado.",
    api140: "No se encontró la Regla a eliminar.",
    api141: "Regla eliminada exitosamente.",
    api142: "Regla no encontrada.",
    api143: "Regla ya creada con estos valores.",
    api144: "Regla registrada con éxito.",
    api145: "Regla actualizada con éxito.",
    api146:
      "Se produjo un error al intentar descargar el pdf o la vista previa.",
    api147:
      "El envío de un mensaje de raspado a la cola se completó con éxito.",
    api148: "Evaluación no encontrada",
    api149: "Evaluación sin respuestas registradas",
    api150:
      "Las siguientes respuestas tienen técnicas para procesar correctamente.",
    api151: "Evaluación registrada exitosamente",
    api152: "Evaluación actualizada con éxito",
    api153: "Evaluación(es) eliminada(s) con éxito",
    api154: "La respuesta no encontrada",
    api155: "Archivo diferente al de la base.",
    api156:
      "Para aceptar la Evaluación, es necesario descargar el listado de preguntas.",
    api157:
      "Para aceptar la Evaluación, es necesario enviar un expediente de evidencia.",
    api158:
      "La descarga del listado de preguntas sólo se podrá completar si la Evaluación se ha completado por completo.",
    api159: "La aceptación del cliente ya se ha realizado.",
    api160: "Fallo en el registro/actualización de datos de evaluación",
    api161: "La evaluación no se puede eliminar.",
    api162: "Falló la grabación del archivo",
    api163: "Extensión de archivo inválida",
    api164: "No se encontró la evaluación que se va a eliminar",
    api165: "Tipo de mitigación obligatoria",
    api166: "Error al excluir(s) informe(s)",
    api167: "Informe(s) excluido(s) exitosamente",
    api168: "Informe no encontrado",
    api169:
      "El registro de resultado de los analizadores se completó con éxito.",
    api170:
      "La actualización del resultado del analizador se realizó correctamente.",
    api171: "La habilidad no se puede editar",
    api172: "Habilidad editada exitosa",
    api173: "No se pudo eliminar la carga útil"
  }
}

export default backend
